var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('p',[_vm._v("© 2025 IT Support Duda. All rights reserved.")]),_c('p',[_vm._v("Kontaktiere uns: support@duda.com")])])
}]

export { render, staticRenderFns }